module.exports = "mutation bulkAddProductImages($csv:String!){bulkAddProductImages(csv:$csv){id productImages{id imageUrl default}}}"